/** The layout viewport's width in CSS px; 0 outside a browser. */
export function viewportWidth(): number {
  if (typeof window === 'undefined') return 0;
  return window.innerWidth;
}
